import { createFileRoute } from '@tanstack/react-router'
import { RelatorioAbsenteismo } from '@/features/relatorios-absenteismo'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute(
  '/_authenticated/relatorios/absenteismo/',
)({
  beforeLoad: async () => {
    await requireAdmin()
  },
  component: RelatorioAbsenteismo,
})
